import './styles.scss'
import { registerPortlet } from '@neptune/cx/registry';
import { DisposalSet, select } from '@neptune/cx/utils';

const gc = new DisposalSet();

interface EducationHoursEntryPortletConfig {
    providerOtherId: number;
    fields: {
        form: string;
        startDate: string;
        endDate: string;
        hours: string;
        minutes: string;
        type: string;
        providerId: string;
        activityCategoryId: string;
        organizationName: string;
    }
}

registerPortlet<EducationHoursEntryPortletConfig>('cbdce-education-hours-entry-portlet', (portletEL, config, meta) => {
    const upsertForm = portletEL.querySelector('.cbdce-education-hours-entry-portlet--upsert');
    if (!upsertForm) return;

    const formEl = select<HTMLFormElement>(portletEL, `form[name="${config.fields.form}"]`);

    // const startDateInputEl = select<HTMLInputElement>(portletEL, `input[name="${config.fields.startDate}"]`);
    // const endDateInputEl = select<HTMLInputElement>(portletEL, `input[name="${config.fields.endDate}"]`);
    const hoursInputEl = select<HTMLInputElement>(portletEL, `input[name="${config.fields.hours}"]`);
    const minutesInputEl = select<HTMLInputElement>(portletEL, `input[name="${config.fields.minutes}"]`);

    const typeFormalRadioEl = select<HTMLInputElement>(
        portletEL, `input[name="${config.fields.type}"][value="formal"]`
    );
    const typeExpandedRadioEl = select<HTMLInputElement>(
        portletEL, `input[name="${config.fields.type}"][value="expanded"]`
    );
    const providerIdSelectEl = select<HTMLSelectElement>(portletEL, `select[name="${config.fields.providerId}"]`);
    const providerIdWrapperEl = providerIdSelectEl.closest('.field-wrapper')!;
    const activityCategoryIdSelectEl = select<HTMLSelectElement>(
        portletEL, `select[name="${config.fields.activityCategoryId}"]`
    );
    const activityCategoryIdWrapperEl = activityCategoryIdSelectEl.closest('.field-wrapper')!;
    const organizationNameInputEl = select<HTMLInputElement>(
        portletEL, `input[name="${config.fields.organizationName}"]`
    );
    const organizationNameWrapperEl = organizationNameInputEl.closest('.field-wrapper')!;

    // gc.register(startDateInputEl).addListener('change', () => {
    //     if (startDateInputEl.value) {
    //         endDateInputEl.min = startDateInputEl.value;
    //     } else {
    //         endDateInputEl.removeAttribute('min');
    //     }
    // });
    // gc.register(endDateInputEl).addListener('change', () => {
    //     if (endDateInputEl.value) {
    //         startDateInputEl.max = endDateInputEl.value;
    //     } else {
    //         startDateInputEl.removeAttribute('max');
    //     }
    // });

    const cleanOnBlur = (event: FocusEvent) => {
        const targetEl = event.target! as HTMLInputElement;
        // srip and leading zeros. Remove perios and anything after it to prevent decimals
        targetEl.value = targetEl.value.replace(/^0+/, '').replace(/\..*$/, '');
        if (targetEl.value === '') {
            targetEl.value = '0';
        }
    };
    const cleanOnPaste = (event: ClipboardEvent) => {
        const targetEl = event.target! as HTMLInputElement;
        const pastedData = event.clipboardData?.getData('text') || '';
        // if pasted data contains anything other than digits, revert to pre-paste value
        if (!/^\d+$/.test(pastedData)) {
            const oldValue = targetEl.value;
            setTimeout(() => targetEl.value = oldValue, 250);
        }
    };
    const preventNonDigits = (event) => {
        // prevent any decimals from being typed into text input
        if (event.key === '.') {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    gc.register(hoursInputEl).addListener('paste', cleanOnPaste);
    gc.register(hoursInputEl).addListener('keydown', preventNonDigits);
    gc.register(hoursInputEl).addListener('blur', cleanOnBlur);
    gc.register(minutesInputEl).addListener('paste', cleanOnPaste);
    gc.register(minutesInputEl).addListener('keydown', preventNonDigits);
    gc.register(minutesInputEl).addListener('blur', (e) => {
        let minutes = parseInt(minutesInputEl.value, 10);
        if (isNaN(minutes) || minutes < 0) {
            minutes = 0;
        } else if (minutes > 59) {
            // apply overflow to hours
            const hours = Math.floor(minutes / 60);
            minutes = minutes % 60;
            minutesInputEl.value = String(minutes);
            hoursInputEl.value = String(parseInt(hoursInputEl.value, 10) + hours);
        }

        cleanOnBlur(e);
    });

    const updateFieldVisibility = () => {
        if (typeFormalRadioEl.checked) {
            activityCategoryIdWrapperEl.classList.add('form-group--hidden');

            if (providerIdSelectEl.value === String(config.providerOtherId)) {
                organizationNameWrapperEl.classList.remove('form-group--hidden')
            } else {
                organizationNameWrapperEl.classList.add('form-group--hidden');
            }
            providerIdWrapperEl.classList.remove('form-group--hidden');
        } else {
            providerIdWrapperEl.classList.add('form-group--hidden');
            activityCategoryIdWrapperEl.classList.remove('form-group--hidden');
            organizationNameWrapperEl.classList.remove('form-group--hidden');
        }
    };
    gc.register(typeFormalRadioEl).addListener('change', () => {
        updateFieldVisibility();
    });
    gc.register(typeExpandedRadioEl).addListener('change', () => {
        updateFieldVisibility();
    });
    gc.register(providerIdSelectEl).addListener('change', () => {
        updateFieldVisibility();
    });
    gc.register(formEl).addListener('submit', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});


if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(gc.disposeAll);
}